export class CommonConstant {
    public static loader = 'loader-1';
    public static reOpenSuccess = "Event has been successfully reopened.";
    public static reOpenFailure = "Event could not be reopened.";
}